import { useState, useEffect, useRef } from "react";
import api from "../../axiosconfig";

const empty = { summaries: {}, aiSummary: "", loading: false, error: "" };

export default function usePearliAiSummary(viewMode, scores, loadingScores, hasData, requestKey) {
    const [state, setState] = useState(empty);
    const requestRef = useRef(null);
    const payload = [scores.physical, scores.emotional, scores.acceptance,
        scores.relationships, scores.loving_kindness, scores.intellectual];
    const eligible = viewMode === "current" && !loadingScores && hasData
        && payload.every(Number.isFinite);
    const key = eligible ? JSON.stringify([requestKey, payload]) : null;

    useEffect(() => {
        if (!key) {
            setState(empty);
            return undefined;
        }
        let active = true;
        // Reuse the same in-flight request during React's effect replay.
        if (requestRef.current?.key !== key) {
            requestRef.current = { key, promise: api.post("/api/pearli/analyze", {
                scores: JSON.parse(key)[1],
            }) };
        }
        const request = requestRef.current;
        setState({ ...empty, key, loading: true });
        request.promise.then((res) => {
            const data = res?.data?.data;
            if (!data) throw new Error("Missing analysis");
            if (active) setState({ key, loading: false, error: "",
                aiSummary: data.GeneralSummary || "",
                summaries: {
                    physical: data.PhysicalSummary || "",
                    emotional: data.EmotionalSummary || "",
                    acceptance: data.AcceptanceSummary || "",
                    relationships: data.RelationshipSummary || "",
                    loving_kindness: data.LovingKindnessSummary || "",
                    intellectual: data.IntellectualSummary || "",
                },
            });
        }).catch(() => {
            if (requestRef.current === request) requestRef.current = null;
            if (active) setState({ ...empty, key,
                error: "AI analysis is temporarily unavailable. Assessment scores are still available." });
        });
        return () => { active = false; };
    }, [key]);

    return key && state.key === key ? state : { ...empty, loading: Boolean(key) };
}
